module.exports = __webpack_public_path__ + "static/Animations-64b4a389efa0e857808221c3fc882138.svg";